import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit'
import { addItem, removeItem, setQuantity, clearCart } from '.'
import { STOREFRONT_CART_REDUCER } from '@/constants'
import { writeCart } from './storage'
import { CartState } from './types'

export const cartListener = createListenerMiddleware()

cartListener.startListening({
  matcher: isAnyOf(setQuantity, addItem, removeItem, clearCart),
  effect: (_action, listenerApi) => {
    const updatedRootState = listenerApi.getState() as {
      [STOREFRONT_CART_REDUCER]: CartState
    }
    writeCart(updatedRootState[STOREFRONT_CART_REDUCER])
  },
})
